import React, { useState } from 'react';
import { Button } from '@mui/material';
import { useAppDispatch } from '../../../../../redux/store.model';
import { useShowErrorMessage } from '../../../../../handlingErrors';
import { useNavigate } from 'react-router-dom';
import { useShowMessage } from '../../../../../util/hooks';
import { getPolyglot } from '../../../../../i18n';
import { STModal } from '../../../../../components/commons/Modal';
import ButtonLoading from '../../../../../components/commons/ButtonLoading/ButtonLoading';
import { deleteGroup } from '../../../../../redux/groups/actions/thunks';

interface GroupDeleteProps {
  showDeleteGroup: boolean;
  closeDeleteGroup: () => void;
  groupId: string;
}
/**
 * Group Delete
 * This class allow remove a group
 */
export function DeleteStoreModal(props: GroupDeleteProps) {
  const { closeDeleteGroup, groupId, showDeleteGroup } = props;
  const dispatch = useAppDispatch();
  const showErrorMessage = useShowErrorMessage();
  const navigate = useNavigate();
  const showMessage = useShowMessage();
  const polyglot = getPolyglot();

  const [loading, setLoading] = useState(false);

  const goBackPrevGroup = () => {
    navigate(`/`);
  };

  /**
   * Delete group
   * this function call the backend to remove a group
   */
  const onClickDeleteGroup = async () => {
    setLoading(true);
    try {
      await dispatch(deleteGroup(groupId));
      /* show snack bar with successful message */
      closeDeleteGroup();
      goBackPrevGroup();
      showMessage(polyglot.t('freshwatch.store.delete_success'));
    } catch (error) {
      showErrorMessage(error);
    }

    setLoading(false);
  };

  return (
    <STModal
      open={showDeleteGroup}
      title={polyglot.t('freshwatch.store.delete')}
      onClose={closeDeleteGroup}
      buttonActions={
        <>
          <Button onClick={closeDeleteGroup} variant="text">
            {polyglot.t('group.cancel_button_title')}
          </Button>
          <ButtonLoading
            variant="contained"
            color="error"
            onClick={onClickDeleteGroup}
            loading={loading}
          >
            {polyglot.t('group.delete_button_title')}
          </ButtonLoading>
        </>
      }
    >
      <p>{polyglot.t('freshwatch.store.delete_message')}</p>
    </STModal>
  );
}

export default DeleteStoreModal;
